import React, { useEffect, useMemo, useState,useRef } from "react";
import { motion } from "framer-motion";
import logo from "./components/logo.jpg";
import vtlogo from "./components/vtlogo.png";
import ruxstarlogo from "./components/ruxstarlogo.png";
import cmrtclogo from "./components/cmrtclogo.png";
import { FaWhatsapp } from "react-icons/fa";
import pe1 from "./components/posteventphotos/pe1.jpg";
import pe2 from "./components/posteventphotos/pe2.jpg";
import pe3 from "./components/posteventphotos/pe3.jpg";
import pe4 from "./components/posteventphotos/pe4.jpg";
import pe5 from "./components/posteventphotos/pe5.jpg";
import pe6 from "./components/posteventphotos/pe6.jpg";
import pe7 from "./components/posteventphotos/pe7.jpg";
import pe8 from "./components/posteventphotos/pe8.jpg";
import pe9 from "./components/posteventphotos/pe9.jpg";
import pe10 from "./components/posteventphotos/pe10.jpg";
import pe11 from "./components/posteventphotos/pe11.jpg";
import pe12 from "./components/posteventphotos/pe12.jpg";
import pe13 from "./components/posteventphotos/pe13.jpg";
import pe14 from "./components/posteventphotos/pe14.jpg";






import {  doc, getDoc, setDoc, onSnapshot, updateDoc  } from "firebase/firestore";
import { db } from "./firebase"; // make sure this points to your Firebase config
// import useCountdown from "../hooks/useCountdown";

import { GraduationCap, Sprout, UserPlus } from "lucide-react";
import banner from "./components/banner.jpg";
import useWindowSize from "react-use/lib/useWindowSize";
import Confetti from "react-confetti";
import {
  Calendar,
  CalendarDays,
  Clock,
  ChevronDown,
  Rocket,
  Users,
  Lightbulb,
  Cpu,
  HeartPulse,
  Landmark,
  ShieldCheck,
  Gift,
  Trophy,
  Mail,
  Phone,
  Instagram,
  
  Twitter,
  Linkedin,
  Banknote,
  Stethoscope,
  Leaf,
  MapPin,Circle,Flag,
} from "lucide-react";


const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
};
const item = {
  hidden: { y: 12, opacity: 0 },
  show: { y: 0, opacity: 1, transition: { type: "spring", stiffness: 140 } },
};

function useCountdown(targetDate) {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const diff = Math.max(0, targetDate.getTime() - now.getTime());
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
      setTimeLeft({ days, hours, minutes, seconds });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [targetDate]);
  return timeLeft;
}

function SectionHeading({ eyebrow, title, subtitle }) {
  return (
    <div className="mx-auto max-w-3xl text-center mb-10">
      {eyebrow && (
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gradient-to-r from-cyan-500/15 to-emerald-500/15 text-cyan-700 ring-1 ring-cyan-500/20 text-xs font-medium">
          <Rocket className="h-4 w-4" /> {eyebrow}
        </div>
      )}
      <h2 className="mt-4 text-3xl md:text-4xl font-extrabold tracking-tight bg-gradient-to-r from-cyan-600 to-emerald-600 bg-clip-text text-transparent">
        {title}
      </h2>
      {subtitle && <p className="mt-3 text-slate-600">{subtitle}</p>}
    </div>
  );
}

// function Pill({ value, label }) {
//   return (
//     <div className="flex flex-col items-center justify-center rounded-2xl bg-white/80 backdrop-blur border border-slate-200 px-5 py-3 shadow-sm">
//       <div className="text-3xl md:text-4xl font-extrabold text-slate-800 tabular-nums">{value}</div>
//       <div className="text-[10px] uppercase tracking-widest text-slate-500">{label}</div>
//     </div>
//   );
// }
// function Pill({ value, label }) {
//   return (
//     <div className="flex flex-col items-center justify-center bg-white/90 border border-slate-300 rounded-3xl p-12 md:p-20 shadow-xl">
//       {/* HUGE numbers */}
//       <span className="font-extrabold text-7xl md:text-9xl">{value}</span>
//       {/* Bigger labels */}
//       <span className="mt-4 text-3xl md:text-5xl font-semibold">{label}</span>
//     </div>
//   );
// }
function Pill({ value, label }) {
  return (
    <div className="flex flex-col items-center justify-center bg-white/90 border border-slate-300 rounded-2xl 
                    p-4 sm:p-6 md:p-12 lg:p-16 shadow-xl">
      {/* Responsive numbers */}
      <span className="font-extrabold text-4xl sm:text-5xl md:text-7xl lg:text-9xl">
        {value}
      </span>
      {/* Responsive labels */}
      <span className="mt-2 sm:mt-3 md:mt-4 text-base sm:text-lg md:text-3xl lg:text-5xl font-semibold">
        {label}
      </span>
    </div>
  );
}


function Navbar() {
  const links = [
    { id: "about", label: "About" },
    { id: "schedule", label: "Schedule" },
    { id: "tracks", label: "Themes" },
    { id: "prizes", label: "Prizes" },
    { id: "sponsors", label: "Sponsors" },
    { id: "faq", label: "FAQ" },
    { id: "contact", label: "Contact" },
  ];
  const handleClick = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    el?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <div className="fixed inset-x-0 top-0 z-50">
  <div className="mx-auto max-w-7xl px-4">
    <div className="mt-3 rounded-2xl bg-white/70 backdrop-blur supports-[backdrop-filter]:bg-white/60 border border-slate-200 shadow-lg">
      <div className="flex items-center justify-between px-4 py-3">
        <a
          href="#hero"
          className="flex items-center font-black tracking-tight text-slate-800 text-lg gap-2"
          onClick={(e) => handleClick(e, "hero")}
        >
          <img src={logo} alt="NeuraX Logo" className="h-10 w-10 rounded" />
          <span>
            Neura<span className="bg-gradient-to-r from-cyan-600 to-emerald-600 bg-clip-text text-transparent">X</span>
          </span>
        </a>

        {/* Navbar Links */}
        <div className="flex items-center gap-4">
        <nav className="hidden md:flex items-center gap-6 text-sm text-slate-600">
          {links.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={(e) => handleClick(e, l.id)}
              className="hover:text-slate-900 transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
  href="https://forms.gle/nZ56KhkQ3cznUVXE7" 
  target="_blank"
  rel="noopener noreferrer"
  className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-cyan-600 to-emerald-600 px-4 py-2 text-white font-semibold shadow hover:shadow-md hover:opacity-95 active:opacity-90"
>
  <UserPlus className="h-4 w-4" /> Register
</a>
</nav>
<img
                src={vtlogo}
                alt="vtLogo"
                className="h-10 w=10 object-contain rounded"
              />
              <img
                src={cmrtclogo}
                alt="Logo 2"
                className="h-12 w-12 object-contain rounded"
              />
              </div>
      </div>
    </div>
  </div>
</div>

  );
}



// import { useState, useEffect, useMemo } from "react";
// import { motion } from "framer-motion";
// import { Calendar, MapPin, ChevronDown } from "lucide-react";
// import useCountdown from "../hooks/useCountdown"; // your countdown hook
// import Pill from "./Pill"; // your countdown pill component

function Hero() {
  // ✅ Set event end time directly in code
  const eventEndTime = useMemo(() => new Date("2025-10-09T12:00:00"), []); 
  const { hours, minutes, seconds } = useCountdown(eventEndTime);
  const isLive = new Date() < eventEndTime;

  // ✅ Event images for slideshow
  const images = [
    pe1,pe2,pe3,pe4,pe5,pe6,pe7,pe8,pe9,pe10,pe11,pe12,pe13,pe14,
    
  ];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className="relative overflow-hidden pt-20 md:pt-20 w-full bg-gradient-to-br from-cyan-50 via-white to-emerald-50">

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-cyan-100 via-emerald-100 to-white opacity-70 blur-3xl"></div>

      <div className="mx-auto w-full max-w-7xl px-4 flex flex-col items-center relative z-10">
        {/* ===== Event Status Section ===== */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="flex flex-col items-center mb-8"
        >
          {/* Event Status Banner */}
          {/* <motion.div
            animate={{ scale: [1, 1.05, 1] }}
            transition={{ repeat: Infinity, repeatType: "loop", duration: 1.5 }}
            className={`${
              isLive
                ? "bg-gradient-to-r from-cyan-600 to-emerald-600"
                : "bg-gradient-to-r from-red-600 to-orange-500"
            } text-white px-10 py-8 rounded-3xl shadow-2xl font-extrabold text-4xl md:text-6xl text-center tracking-wider uppercase`}
          >
            {isLive ? "🚀 Hackathon is LIVE!" : "🏁 Hackathon has ENDED"}
          </motion.div> */}
          <motion.div
  animate={{ scale: [1, 1.05, 1] }}
  transition={{ repeat: Infinity, repeatType: "loop", duration: 1.5 }}
  className={`${
    isLive
      ? "bg-gradient-to-r from-cyan-600 to-emerald-600"
      : "bg-gradient-to-r from-red-600 to-orange-500"
  } text-white px-10 py-6 rounded-3xl shadow-2xl font-extrabold text-4xl md:text-5xl text-center tracking-wider uppercase
     flex items-center justify-center min-h-[100px] md:min-h-[10px]`}
>
  {isLive ? "🚀 Hackathon is LIVE!" : "🏁 Hackathon has ENDED"}
</motion.div>




          {/* Countdown Pills */}
          {isLive && (
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="flex flex-wrap justify-center gap-4 sm:gap-6 md:gap-12 mt-8"
            >
              <Pill value={String(hours).padStart(2, "0")} label="Hours" />
              <Pill value={String(minutes).padStart(2, "0")} label="Minutes" />
              <Pill value={String(seconds).padStart(2, "0")} label="Seconds" />
            </motion.div>
          )}
        </motion.div>
</div>
        <div className="flex justify-center mt-8 px-4">
  <div
    className="relative w-full max-w-4xl h-64 sm:h-80 md:h-96 rounded-2xl overflow-hidden shadow-2xl
               flex items-center justify-center
               bg-gradient-to-br from-cyan-100 via-white/20 to-emerald-100">

    {/* Light gradient overlay for subtle effect */}
    <div className="absolute inset-0 bg-gradient-to-r from-cyan-200 via-white/20 to-emerald-200 opacity-30 blur-xl"></div>

    {images.map((img, index) => (
      <motion.img
        key={index}
        src={img}
        alt={`Event ${index + 1}`}
        className={`absolute transition-opacity duration-1000
                    ${index === currentImage ? "opacity-100" : "opacity-0"}
                    max-w-full max-h-full object-contain`}
      />
    ))}

    {/* Image indicators (dots) */}
    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
      {images.map((_, idx) => (
        <div
          key={idx}
          className={`w-3 h-3 rounded-full ${
            idx === currentImage ? "bg-emerald-500" : "bg-white/50"
          }`}
        />
      ))}
    </div>
  </div>
</div>










      {/* ===== Event Information Section ===== */}
      <div className="mx-auto flex flex-col items-center text-center space-y-4 max-w-2xl mt-12 relative z-10">
        <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white/70 px-3 py-1 text-xs text-slate-600 backdrop-blur">
          <Calendar className="h-4 w-4 text-cyan-600" /> Sep 20–21, 2025 ·
          Offline ·{" "}
          <span className="inline-flex items-center gap-1">
            <MapPin className="h-3.5 w-3.5 text-emerald-600" /> CMR Technical
            Campus
          </span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-6xl font-black leading-tight break-words">
          Neura
          <span className="bg-gradient-to-r from-cyan-600 to-emerald-600 bg-clip-text text-transparent">
            X
          </span>
          <span className="block text-xl sm:text-2xl md:text-4xl font-bold text-slate-700">
            HACKATHON 2025
          </span>
        </h1>

        <p className="text-slate-600 text-sm sm:text-base md:text-lg">
          Your Code. Your Vision. Your Legacy. <br />
          At NeuraX Hackathon 2025, every line of code is more than just syntax
          — it’s a step toward shaping the future.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://forms.gle/nZ56KhkQ3cznUVXE7"
            target="_blank"
            className="inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-cyan-600 to-emerald-600 px-5 py-3 text-white font-semibold shadow hover:shadow-md w-full sm:w-auto"
          >
            Register Now
          </a>
          <a
            href="#about"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("about")?.scrollIntoView({
                behavior: "smooth",
              });
            }}
            className="group inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white/70 px-5 py-3 font-medium text-slate-700 backdrop-blur hover:bg-white w-full sm:w-auto justify-center"
          >
            Learn more{" "}
            <ChevronDown className="h-4 w-4 transition-transform group-hover:translate-y-0.5" />
          </a>
        </div>
      </div>
    </section>
  );
}








function About() {
  const highlights = [
    { icon: <Lightbulb className="h-5 w-5" />, title: "Innovation", desc: "Explore cutting-edge ideas with mentorship and rapid prototyping." },
    { icon: <Users className="h-5 w-5" />, title: "Collaboration", desc: "Meet talented peers, form teams, and build together." },
    { icon: <Trophy className="h-5 w-5" />, title: "Prizes", desc: "Win cash, Internships, Certificates" },
  ];
  return (
    <section id="about" className="relative py-20">
      <div className="mx-auto max-w-7xl px-4">
        <SectionHeading
          eyebrow="Why join?"
          title="About the Hackathon"
          subtitle="Bring your boldest vision, transform it into reality, and create a legacy that inspires beyond the 24 hours.
This is where innovation meets impact, and your ideas leave a mark on tomorrow."
        />
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-50px" }}
          className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3"
        >
          {highlights.map((h, i) => (
            <motion.div
              key={i}
              variants={item}
              className="rounded-3xl border border-slate-200 bg-white/80 p-6 shadow-sm backdrop-blur hover:shadow-md transition-shadow"
            >
              <div className="flex items-center gap-3">
                <div className="rounded-xl bg-gradient-to-br from-cyan-100 to-emerald-100 p-2 text-cyan-700">{h.icon}</div>
                <div className="font-semibold">{h.title}</div>
              </div>
              <p className="mt-3 text-sm text-slate-600">{h.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

// import { Calendar, Clock, Flag } from "lucide-react";


function ActivitiesTimeline() {
  const now = new Date();

  const events = useMemo(
    () => [
      {
        title: "Registration & Team Formation",
        desc: "Participants can register online and form teams (max 3 members).",
        date: { month: "Sep", day: "01" },
        timeline: "Monday, Sep 01, 10:00 AM to Sep 14, 11:59 PM",
        start: new Date("2025-09-01T10:00:00"),
        end: new Date("2025-09-14T23:59:00"),
      },
      {
        title: "Round-1 Idea Submission(Online)",
        desc: "Teams submit a proposed AI-driven solution.",
        date: { month: "Sep", day: "02" },
        timeline: "Tuesday, Sep 02, 10:00 AM to Sep 14, 11:59 PM",
        start: new Date("2025-09-02T10:00:00"),
        end: new Date("2025-09-14T23:59:00"),
      },
      {
        title: "Round-1 Results",
        desc: "Top 30 teams will be shortlisted for next round",
        date: { month: "Sep", day: "15" },
        timeline: "Monday, Sep 15, 07:00 PM",
        start: new Date("2025-09-15T19:00:00"),
        end: new Date("2025-09-16T06:00:00"),
      },
      {
        title: "Payment for Round-2",
        desc: "Shortlisted students need to pay the Rs.699/- fee for Round-2",
        date: { month: "Sep", day: "16" },
        timeline: "Tuesday, Sep 16, 06:00 AM to Sep 16, 11:59 PM",
        start: new Date("2025-09-16T06:00:00"),
        end: new Date("2025-09-16T23:59:00"),
      },
      {
        title: "Round-2",
        desc: "Selected 45 teams will compete on the day of HACKATHON at CMR Technical Campus, Hyderabad.",
        date: { month: "Sep", day: "20" },
        timeline: "Saturday, Sep 20, 10:00 AM to Sep 21, 10:00 AM",
        start: new Date("2025-09-20T10:00:00"),
        end: new Date("2025-09-21T10:00:00"),
      },
    ],
    []
  );

  // Function to determine label + color dynamically
  const getStatus = (event) => {
    if (now < event.start) {
      return { label: "Upcoming", color: "bg-blue-50 text-blue-500 border border-blue-400" };
    } else if (now >= event.start && now <= event.end) {
      return { label: "Ongoing", color: "bg-green-50 text-green-600 border border-green-400" };
    } else {
      return { label: "Completed", color: "bg-red-50 text-red-500 border border-red-400" };
    }
  };

  return (
    <section id="activities" className="relative p-5">
     <div className="mx-auto max-w-7xl px-4">
        <SectionHeading
          // eyebrow="Plan your sprint"
          title="Important Dates"
          // subtitle="A clear timeline to help you focus and ship."
        />
        </div>

      <div className="space-y-0">
        {events.map((event, i) => {
          const status = getStatus(event);

          return (
            <div key={i} className="flex gap-4 relative pb-32">
              {/* Timeline Line */}
              {i !== events.length - 1 && (
                <div className="absolute top-0 bottom-0 left-5 z-0 w-[2px] bg-indigo-500 opacity-50" />
              )}

              {/* Icon Circle */}
              <div className="w-10 h-10 bg-indigo-50 relative z-10 rounded-full flex items-center justify-center">
                <CalendarDays className="w-6 h-6 text-indigo-800" />
              </div>

              {/* Event Content */}
              <div className="w-full">
                <div className="px-4">
                  <div className="flex flex-col sm:flex-row justify-between items-start">
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold relative text-gray-800">
                        {event.title}
                      </h3>
                      <p className="text-gray-600 mt-1">{event.desc}</p>
                    </div>

                    {event.date && (
                      <div className="w-[60px] my-4 sm:my-0">
                        <div className="text-center">
                          <div className="bg-gradient-to-r from-cyan-600 to-emerald-600 rounded-t-lg py-1 text-white">
                            {event.date.month}
                          </div>
                          <div className="border border-t-0 rounded-b-lg px-4 py-2 font-semibold text-xl">
                            {event.date.day}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Timeline + Status */}
                  <div className="py-3 border-b border-t mt-4">
                    <div className="flex flex-col lg:flex-row lg:items-center gap-4">
                      <div className="text-gray-600 text-sm">{event.timeline}</div>
                      <div className="flex-1 lg:text-right">
                        <div
                          className={`inline-block px-4 py-2 rounded-3xl select-none pointer-events-none ${status.color}`}
                        >
                          {status.label}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

function Schedule() {
  const rows = [
    { day: "Day 1", items: [
      { time: "09:00", title: "Check-in & Verification" },
      { time: "09:30", title: "Opening Cermony" },
      { time: "10:00", title: "Hacking Begins" },
      { time: "14:00", title: "Lunch" },
      { time: "17:00", title: "Activity & Checkpoint" },
       { time: "20:00", title: "Dinner" },
       { time: "23:00", title: "Checkpoint" },
     
    ]},
    { day: "Day 2", items: [
      { time: "01:00", title: "Refreshment" },
      { time: "06:00", title: "Checkpoint" },
      { time: "08:00", title: "Breakfast" },
      { time: "10:00", title: "Project submission" },
       { time: "12:00", title: "Awards & Closing Cermony" },
    ]},
  ];
  return (
    <section id="schedule" className="relative py-20">
      <div className="mx-auto max-w-7xl px-4">
        <SectionHeading eyebrow="Plan your sprint" title="Event Schedule" subtitle="A clear timeline to help you focus and ship." />
        <div className="grid gap-6 lg:grid-cols-2">
          {rows.map((col, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5 }}
              className="rounded-3xl border border-slate-200 bg-white/80 p-6 shadow-sm backdrop-blur"
            >
              <div className="mb-4 flex items-center gap-2">
                <Calendar className="h-5 w-5 text-cyan-600" />
                <h3 className="text-lg font-semibold">{col.day}</h3>
              </div>
              <ol className="relative ml-3 border-l border-slate-200">
                {col.items.map((it, i) => (
                  <li key={i} className="mb-6 ml-4">
                    <div className="absolute -left-[9px] mt-1 h-4 w-4 rounded-full border border-slate-200 bg-white" />
                    <div className="flex items-center gap-3">
<span className="inline-flex items-center gap-1 rounded-full bg-slate-50 px-2 py-1 text-xs font-medium text-slate-600 ring-1 ring-slate-200">
                        <Clock className="h-3.5 w-3.5" /> {it.time}
                      </span>
                      <div className="font-medium">{it.title}</div>
                    </div>
                  </li>
                ))}
              </ol>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}




function Tracks() {
  const [activeIndex, setActiveIndex] = useState(null);

  const cards = [
    { 
      icon: <Sprout className="h-5 w-5" />, 
      title: "AI in Agriculture", 
      desc: "From soil to cloud — AI for better yields.",
      problem: (
        <ul className="list-disc ml-6 mt-1 space-y-1">
          <p>Build a mobile application for farmers where they can capture an image of their crop. The AI model should:</p>
          <li>Detect diseases in the crop.</li>
          <li>Suggest suitable pesticides.</li>
          <li>Provide recommendations in both Telugu and English, with an AI voice assistant for better accessibility.</li>
        </ul>
      )
    },
    { 
      icon: <GraduationCap className="h-5 w-5" />, 
      title: "AI in Education", 
      desc: "Empowering minds through intelligent learning.",
      problem: (
        <ul className="list-disc ml-6 mt-1 space-y-1">
          <p>Develop an AI-powered smart attendance system:</p>
          <li>where a single classroom image can be used to automatically mark attendance for all students present.</li>
          <li>The system should accurately recognize faces, handle multiple students in one frame, and generate attendance reports.</li>
        </ul>
      )
    },
    { 
      icon: <HeartPulse className="h-5 w-5" />, 
      title: "AI in HealthCare", 
      desc: "AI at the heart of better healthcare.",
      problem: (
        <ul className="list-disc ml-6 mt-1 space-y-1">
          <p>Create an AI-based diagnostic system to analyze kidney scan images and:</p>
          <li>Detect the presence of kidney stones.</li>
          <li>Identify the size and location of the stone.</li>
          <li>Generate a detailed report for doctors and patients.</li>
        </ul>
      )
    },
  ];

  const handleCardClick = (i) => {
    setActiveIndex(activeIndex === i ? null : i);
  };

  return (
    <section id="tracks" className="relative py-20">
      <div className="mx-auto max-w-7xl px-4">
        <SectionHeading 
          eyebrow="Choose your lane" 
          title="Themes & Problem Statements" 
          subtitle="Pick a theme or propose your own wild card." 
        />

        <div className="grid gap-6 sm:grid-cols-1 lg:grid-cols-3">
          {cards.map((c, i) => (
            <div key={i}>
              {/* Card */}
              <motion.div 
                onClick={() => handleCardClick(i)}
                whileHover={{ scale: 1.03 }}
                className={`cursor-pointer group rounded-3xl border border-slate-200 bg-white/80 p-6 backdrop-blur shadow-sm transition-shadow hover:shadow-md 
                  ${activeIndex === i ? "ring-2 ring-cyan-500" : ""}`}
              >
                <div className="flex items-center gap-3">
                  <div className="rounded-xl bg-gradient-to-br from-cyan-100 to-emerald-100 p-2 text-cyan-700">{c.icon}</div>
                  <div className="font-semibold">{c.title}</div>
                </div>
                <p className="mt-3 text-sm text-slate-600">{c.desc}</p>
              </motion.div>

              {/* Problem statement - always open on mobile */}
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
                className="mt-3 rounded-2xl border border-slate-200 bg-gradient-to-r from-cyan-50 to-emerald-50 shadow-lg p-5 relative lg:hidden"
              >
                {/** Optional close button only if you want mobile to be closable */}
                {/* <button
                  onClick={() => setActiveIndex(null)}
                  className="absolute top-3 right-3 text-slate-500 hover:text-slate-800"
                >
                  ✕
                </button> */}

                <h3 className="text-base font-bold text-slate-800 mb-2">
                  Problem Statement
                </h3>
                <p className="text-sm text-slate-700 leading-relaxed text-justify">
                  {c.problem}
                </p>
              </motion.div>
            </div>
          ))}
        </div>

        {/* Unified problem statement (Desktop only, click to open) */}
        {activeIndex !== null && (
          <motion.div
            key={activeIndex}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.4 }}
            className="mt-8 hidden lg:block rounded-3xl border border-slate-200 bg-gradient-to-r from-cyan-50 to-emerald-50 p-8 shadow-lg"
          >
            <h3 className="text-lg font-bold text-slate-800 mb-2">
              Problem Statement — {cards[activeIndex].title}
            </h3>
            <p className="text-slate-700 leading-relaxed">
              {cards[activeIndex].problem}
            </p>
          </motion.div>
        )}
      </div>
    </section>
  );
}



// export default Tracks;

function Prizes() {
  const prizes = [
    { icon: <Banknote className="h-6 w-6" />, title: "Worth upto ₹20,000+", desc: "Grand Prize (Team)" },
    // { icon: <Gift className="h-6 w-6" />, title: "Goodies & Swag", desc: "Tees, stickers, gadgets" },
    { icon: <ShieldCheck className="h-6 w-6" />, title: "Merit Certificates", desc: "For your valuable contribution" },
    { icon: <Trophy className="h-6 w-6" />, title: "Direct Internship", desc: "With Vishwasri Technologies Pvt.Ltd" },
  ];
  return (
    <section id="prizes" className="relative py-20">
      <div className="mx-auto max-w-7xl px-4">
        <SectionHeading eyebrow="What you can win" title="Prizes & Rewards" subtitle="More than glory—boost your career and product." />
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {prizes.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.45 }}
              className="rounded-3xl border border-slate-200 bg-white/80 p-6 shadow-sm backdrop-blur hover:shadow-md"
            >
              <div className="flex items-center gap-3">
                <div className="rounded-xl bg-gradient-to-br from-cyan-100 to-emerald-100 p-2 text-cyan-700">{p.icon}</div>
                <div className="font-semibold">{p.title}</div>
              </div>
              <p className="mt-3 text-sm text-slate-600">{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}


function Sponsors() {
  // Replace these with real sponsor data
  const sponsors = [
    {
      name: "Vishwasri Technologies",
      logo: vtlogo, // put logo in public/sponsors folder
      tagline: "Turning Your Ideas into Products!",
    },
    {
      name: "Ruxstar",
      logo: ruxstarlogo,
      tagline: "",
    },
    // {
    //   name: "Sponsor 3",
    //   logo: "/sponsors/innosoft.png",
    //   tagline: "tagline",
    // },
  ];

  return (
    <section id="sponsors" className="relative py-20">
      <div className="mx-auto max-w-7xl px-4">
        <SectionHeading
          eyebrow="Backed by the best"
          title="Innovation Partners"
          subtitle="Thanks to our partners for powering innovation."
        />
        {/* <div className="grid grid-cols-1 sm:grid-cols-1 gap-6"></div> */}
       {/* <div className="flex justify-center gap-6"> */}
       <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-6">

  {sponsors.map((s, i) => (
    <div
      key={i}
      className="flex flex-col items-center justify-center gap-3 h-40 
                       w-full sm:w-80 
                       rounded-2xl border border-slate-200 bg-white/70 backdrop-blur 
                       shadow-sm hover:shadow-md transition p-4 text-center"
    >
              <img
                src={s.logo}
                alt={s.name}
                className="h-12 w-auto object-contain"
              />
              <div className="text-slate-800 font-semibold">{s.name}</div>
              <div className="text-sm text-slate-500">{s.tagline}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}


function FAQ() {
  const qa = [
    { q: "Who can participate?", a: "Anyone with a passion for Innovation and problem solving" },
    { q: "What is the team size?", a: "2-3 members.Should be enclosed at the time of registration" },
    { q: "Is there a registration fee?", a: "Yes. A Nominal fee will be collected after shortlisting" },
    { q: "Will it be online or offline?", a: "Round 1-online , Round 2 - will be conducted offline at CMR Technical Campus,Hyderabad" },
  ];
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="relative py-20">
      <div className="mx-auto max-w-4xl px-4">
        <SectionHeading eyebrow="All you need to know" title="FAQ" />
        <div className="space-y-3">
          {qa.map((item, idx) => (
            <div key={idx} className="rounded-2xl border border-slate-200 bg-white/80 backdrop-blur">
              <button
                onClick={() => setOpen((v) => (v === idx ? -1 : idx))}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <span className="font-medium text-slate-800">{item.q}</span>
                <ChevronDown className={`h-5 w-5 transition-transform ${open === idx ? "rotate-180" : ""}`} />
              </button>
              {open === idx && (
                <div className="px-5 pb-5 text-sm text-slate-600">{item.a}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Contact() {
  return (
    <section id="contact" className="relative py-20">
      <div className="mx-auto max-w-6xl px-4">
        <SectionHeading
          eyebrow="Say hello"
          title="Contact"
          subtitle="Get in touch with us for any queries or collaborations."
        />

        <div className="rounded-3xl border border-slate-200 bg-white/80 p-6 shadow-sm backdrop-blur max-w-3xl mx-auto text-center">
          <div className="mb-4 text-sm text-slate-600">
            For partnership & media queries, reach out anytime.
          </div>
          <div className="flex flex-col items-center justify-center" >
            <a
              href="mailto:neurax@cmrtc.ac.in"
              className="flex items-center gap-3 hover:text-slate-900"
            >
              <Mail className="h-4 w-4 text-cyan-600" /> neurax@cmrtc.ac.in
            </a>
            <a
              href="tel:+917995760212"
              className="flex items-center gap-3 hover:text-slate-900"
            >
              <Phone className="h-4 w-4 text-cyan-600" /> +91 7995760212
            </a>
            <div className="flex items-center gap-4 pt-2">
             <a
    href="https://wa.me/917995760212?text=Hey,%20I%20want%20to%20know%20more%20about%20NuraX%20Hackthon-2025"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="WhatsApp"
    className="rounded-full border border-slate-200 p-2 hover:bg-slate-50"
  >
    <FaWhatsapp className="h-4 w-4 text-green-600" />
  </a>

              <a
                href="https://www.instagram.com/cmrtechnicalcampus?igsh=cWdqMml3aXNldXF1"
                target="_blank"
                aria-label="Instagram"
                className="rounded-full border border-slate-200 p-2 hover:bg-slate-50"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href="https://www.linkedin.com/school/cmrtechnicalcampus/"
                target="_blank"
                aria-label="LinkedIn"
                className="rounded-full border border-slate-200 p-2 hover:bg-slate-50"
              >
                <Linkedin className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}


function Footer() {
   return (
    <footer className="relative bg-black">
      <img 
        src={banner} 
        alt="Footer Banner" 
        className="w-full object-contain max-h-[300px] md:max-h-[400px] mx-auto"
      />
    </footer>
  );
}

export default function HackathonSite() {
  useEffect(() => {
    document.documentElement.classList.add("scroll-smooth", "antialiased");
  }, []);

  return (
    <div className="min-h-screen bg-[radial-gradient(ellipse_at_top_left,rgba(34,211,238,0.06),transparent_40%),radial-gradient(ellipse_at_bottom_right,rgba(52,211,153,0.06),transparent_40%)]">
      <Navbar />
      <main className="pt-4">
        <Hero />
        <About />
        <ActivitiesTimeline/>
        <Schedule />
        <Tracks />
        <Prizes />
        <Sponsors />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}